import { observer } from 'mobx-react';
import React from 'react';
import { useSlate } from 'slate-react';
import { RichTextBoxUtils } from '../RichTextBoxUtils';
import {
  RichTextBoxFormatValue,
  RichTextBoxToolbarButtonBaseProps,
} from '../richTextEditorTypes';
import { RichTextBoxToolbarButton } from './RichTextBoxToolbarButton';

type FormatButtonProps = {
  format: RichTextBoxFormatValue;
} & RichTextBoxToolbarButtonBaseProps;

export const RichTextBoxToolbarFormatButton = observer(
  ({ format, ...props }: FormatButtonProps) => {
    const editor = useSlate();
    const { attrs, ...trimmedProps } = props;
    const { onClick, ...trimmedAttrs } = attrs ?? { onClick: undefined };

    const active = RichTextBoxUtils.isFormatActive(editor, format);

    return (
      <RichTextBoxToolbarButton
        {...trimmedProps}
        {...{ isActive: active }}
        attrs={{
          onClick: (event) => {
            RichTextBoxUtils.toggleFormat(editor, format);
            if (onClick) onClick(event);
          },
          ...trimmedAttrs,
        }}
      />
    );
  },
);
